import { render, staticRenderFns } from "./barre_statut.vue?vue&type=template&id=67a154f2"
import script from "./barre_statut.js?vue&type=script&lang=js&external"
export * from "./barre_statut.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports